import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Auth } from '../../services/Auth'
import { getUserBlockData } from '../../actions/UserActions'
import { Browser } from "../../services/helpers/Browser";
import { SiteLayoutHelper } from '../../services/helpers/SiteLayoutHelper'

// import './info-block.css';

function InfoBlock() {
    const dispatch = useDispatch();
    const playerData = useSelector(state => state.user.playerData.player);
    const userInfoData = useSelector(state => state.user.playerData.userInfoData);
    const isLoggedIn = Auth.isAuthenticated();

    useEffect(() => {
        if (isLoggedIn && playerData && !playerData.isEmailUpdated && playerData.additionalSettingsEnabled) {
            dispatch(getUserBlockData())
        }
    }, [isLoggedIn, JSON.stringify(playerData)])

    //Shame code because of business solution
    const isInfoBlockEnabled = playerData && playerData.additionalSettingsEnabled && SiteLayoutHelper.isFooterVisible();
    return (
        <>
            {isLoggedIn && isInfoBlockEnabled && userInfoData && <div id="info-block" className="tb--information-block tb--justify-center tb--f-11">
                <p className="tb--information-block_text">
                    {!userInfoData['link1'] ? userInfoData['text1'] :
                        <a href={Browser.convertToAbsoluteURL(userInfoData['link1'])} target="_blank">
                            {userInfoData['text1'] ? userInfoData['text1'] : userInfoData['link1']}
                        </a>
                    }
                </p>
                {(userInfoData['link2'] || userInfoData['text2']) &&
                    <p className="tb--information-block_text">
                        {!userInfoData['link2'] ? userInfoData['text2'] :
                            <a href={Browser.convertToAbsoluteURL(userInfoData['link2'])} target="_blank">
                                {userInfoData['text2'] ? userInfoData['text2'] : userInfoData['link2']}
                            </a>
                        }
                    </p>}
            </div>
            }
            
        </>
    )
}

export default InfoBlock;
